import { FormFieldRoot } from '@components/core-ui/form-elements/FormFieldRoot';
import { TProps } from './types/TProps';

const textareaClassName = 'form-control block h-20 w-full resize-none px-4 py-3.5';

export const Textarea = ({
  name = 'textarea',
  label,
  onChange,
  value = '',
  required = false,
  disabled = false,
  error = false,
  className = 'textarea-wrapper w-full',
}: TProps) => {
  const title = `${label}${required ? ' *' : ''}`;
  return (
    <FormFieldRoot disabled={disabled} className={className}>
      <textarea
        className={[textareaClassName, error ? 'form-control--error' : ''].filter(Boolean).join(' ')}
        placeholder={title}
        name={name}
        onChange={onChange}
        required={required}
        disabled={disabled}
        value={value}
      />
    </FormFieldRoot>
  );
};
